import { render } from "./SectionBlock.vue?vue&type=template&id=51dc64b1&scoped=true"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"

import "./SectionBlock.vue?vue&type=style&index=0&id=51dc64b1&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dc64b1"]])

export default __exports__